import React from 'react';
import BaseTable, { BaseTableColumn, FieldData } from '../../components/tables/BaseTable';
import { IEmailAIExtractedData } from '../../types/common';

const ProcessedEmailsTable = ({
    processedEmails,
    pagination,
    setPagination,
    totalCount,
    loading,
}:{
    processedEmails: IEmailAIExtractedData[];
    pagination: { page: number; limit: number; };
    setPagination: (pagination: { page: number; limit: number ;}) => void;
    totalCount: number;
    loading: boolean;
}) => {
    const COLUMNS_TO_RENDER: BaseTableColumn[] = [
        'businessName',
        'dba',
        // 'last4ssn',
        // 'fullName',
        'owners',
        'createdAt',
        'processedActions',
    ];

    return (
        <BaseTable 
            columns={COLUMNS_TO_RENDER}
            data={processedEmails}
            pagination={pagination}
            setPagination={setPagination}
            totalCount={totalCount}
            loading={loading}
        />
    )
}

export default ProcessedEmailsTable;
